export const siteConfig = {
  siteName: "MuzoLab",
  domain: "muzolab.com",
  baseUrl: "https://muzolab.com",
  xHandle: "@muzolab",
  xUrl: "https://x.com/muzolab",
  buildDate: "2026-06-01",
  dreamJarBundleId: "com.muzhoulab.dreamjar"
} as const;

export const locales = [
  { code: "en", htmlLang: "en", ogLocale: "en_US", label: "English", nativeLabel: "English" },
  { code: "ja", htmlLang: "ja", ogLocale: "ja_JP", label: "Japanese", nativeLabel: "日本語" },
  { code: "ko", htmlLang: "ko", ogLocale: "ko_KR", label: "Korean", nativeLabel: "한국어" },
  { code: "zh-CN", htmlLang: "zh-Hans", ogLocale: "zh_CN", label: "Simplified Chinese", nativeLabel: "简体中文" },
  { code: "zh-TW", htmlLang: "zh-Hant", ogLocale: "zh_TW", label: "Traditional Chinese", nativeLabel: "繁體中文" },
  { code: "de", htmlLang: "de", ogLocale: "de_DE", label: "German", nativeLabel: "Deutsch" },
  { code: "fr", htmlLang: "fr", ogLocale: "fr_FR", label: "French", nativeLabel: "Français" },
  { code: "es", htmlLang: "es", ogLocale: "es_ES", label: "Spanish", nativeLabel: "Español" },
  { code: "th", htmlLang: "th", ogLocale: "th_TH", label: "Thai", nativeLabel: "ไทย" }
] as const;

export type Locale = (typeof locales)[number]["code"];

export const defaultLocale: Locale = "en";

export const localeCodes = locales.map((locale) => locale.code) as Locale[];

export const localeMap = Object.fromEntries(locales.map((locale) => [locale.code, locale])) as Record<
  Locale,
  (typeof locales)[number]
>;
